import { render, staticRenderFns } from "./istisnakodu.vue?vue&type=template&id=33d49481"
import script from "./istisnakodu.vue?vue&type=script&lang=js"
export * from "./istisnakodu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports